import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify';
import { v3_ncr_Status_Update } from '../../../actions/v3/ncr';
import RemarksSelect from '../../common/RemarksSelect';
const Header = ({ ncrDetail, setRefresh, refresh }) => {
    const [ncrId, setNcrId] = useState('')

    const [previewItem, setPreviewItem] = useState(null);
    const [pdfUrl, setPdfUrl] = useState(null);
    const [loading, setLoading] = useState(false);


    useEffect(() => {
        if (!previewItem) return;

        setLoading(true);

        const url = `${process.env.REACT_APP_BASE_URL}/v3/ncr/download/preview/${previewItem.ID}`;

        setPdfUrl(url);
        setLoading(false);

    }, [previewItem]);


    // useEffect(() => {
    //     const fetchPdf = async () => {
    //         if (!previewItem) return;

    //         setLoading(true);
    //         setPdfUrl(null);

    //         try {
    //             const response = await fetch(
    //                 `${process.env.REACT_APP_BASE_URL}/v3/ncr/download/pdf/${previewItem?.ID}`

    //             );

    //             if (!response.ok) throw new Error("Failed to download PDF");

    //             const blob = await response.blob();
    //             const fileUrl = URL.createObjectURL(blob);
    //             setPdfUrl(fileUrl);
    //         } catch (err) {
    //             console.error("PDF Preview Error:", err);
    //         } finally {
    //             setLoading(false);
    //         }
    //     };

    //     fetchPdf();

    //     // cleanup on close
    //     return () => {
    //         if (pdfUrl) URL.revokeObjectURL(pdfUrl);
    //         setPdfUrl(null);
    //     };
    // }, [previewItem]);
    const [statusState, setStatusState] = useState({
        status: {
            name: 'status', value: '', error: '', options: ['Draft', 'Open', 'Close'], isRequired: true
        },
        remarks: { name: 'remarks', value: '', error: '', isRequired: false },
    })

    const handleStatusStateChange = (e) => {
        const { name, value } = e.target;
        setStatusState(prev => ({
            ...prev,
            [name]: { ...prev[name], value, error: '' }
        }));
    };
    const handleStatusUpdateSubmit = () => {

        // 1. Validate required fields
        let isValid = true;
        const updatedState = { ...statusState };

        Object.keys(statusState).forEach((key) => {
            if (statusState[key].isRequired && !statusState[key].value) {
                updatedState[key].error = 'This field is required';
                isValid = false;
            }
        });

        setStatusState(updatedState);
        if (!isValid) {
            toast.error('Please fill all required fields.');
            return;
        }

        // 2. Build payload
        const payload = {
            remarks: statusState.remarks.value,
            remark: statusState.remarks.value,
            status: statusState.status.value,
            ncrId: ncrId
        };

        v3_ncr_Status_Update(payload).then((res) => {
            if (res.status) {
                toast.success(res.result.message)
                setRefresh(!refresh)
                const modal = window.bootstrap.Modal.getInstance(document.getElementById(`statusUpdateModal`));
                if (modal) modal.hide();
            }
        })
    };
    return (

        <div className="plan-approval-top-box">
            <div className="info-about-modle-box">
                <div className="mod-box-info">
                    <h5>Serial No.</h5>
                    <p>{ncrDetail?.ID}</p>
                </div>
                <div className="mod-box-info">
                    <h5>NCR Reference Number</h5>
                    <p>{ncrDetail?.NCR_NUMBER}</p>
                </div>
                <div className="mod-box-info">
                    <h5>Category</h5>
                    <p className="cat-para">{ncrDetail?.CATEGORY_NAME}</p>
                </div>
                {/* <div className="mod-box-info">
                    <h5>Deviation From</h5>
                    <p>
                        <span className="cat-para">SPEC</span>{" "}
                        <span className="cat-para second-p">DWG</span>
                    </p>
                </div> */}
                {/* <div className="mod-box-info">
                    <h5>Location </h5>
                    <p>Nav' Dack</p>
                </div>
                <div className="mod-box-info">
                    <h5>Seaspan Rap</h5>
                    <p>Sang Bok Nam</p>
                </div> */}
                <div className="mod-box-info">
                    <h5>Shipyard</h5>
                    <p>{ncrDetail?.SHIPYARD_NAME}</p>
                </div>
                <div className="mod-box-info">
                    <h5>Company</h5>
                    <p>{ncrDetail?.COMPANY_NAME}</p>
                </div>
                <div className="mod-box-info">
                    <h5>Status</h5>
                    <p className='cat-para'>{ncrDetail?.STATUS}</p>
                </div>
            </div>


            <div>


                <a
                    href='#'
                    onClick={() => {
                        setNcrId(ncrDetail.ID);
                    }}
                    data-bs-toggle="modal"
                    data-bs-target={`#statusUpdateModal`}
                    target='_blank'

                    className="btn btn-sm btn-primary me-2"
                    style={{
                        backgroundImage:
                            "linear-gradient(90deg, rgb(104, 149, 180), rgb(38, 85, 120))"
                    }}
                >
                    <i className="bx bx-edit label-icon" /> Change Status

                </a>

                <div
                    className="modal fade"
                    id={`statusUpdateModal`}
                    data-bs-backdrop="static"
                    data-bs-keyboard="false"
                    tabIndex={-1}
                    role="dialog"
                    aria-labelledby="statusUpdateModalLabel"
                    aria-hidden="true"
                >
                    <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="statusUpdateModalLabel">
                                    Update Status
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                />
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-md-12 mb-3">
                                        <label>Status <span >*</span></label>
                                        <select
                                            name={'status'}
                                            value={statusState['status'].value}
                                            onChange={handleStatusStateChange}
                                            className={`form-control ${statusState['status'].error ? 'is-invalid' : ''}`}
                                        >
                                            <option value=''>Select Status</option>
                                            {statusState.status.options.map((status) => {
                                                return (
                                                    <option value={status}>{status}</option>

                                                )
                                            })}
                                        </select>
                                        {statusState['status'].error && <div className="invalid-feedback">{statusState['status'].error}</div>}
                                    </div>

                                    <RemarksSelect
                                        label="Remarks"
                                        name="remarks"
                                        value={statusState.remarks.value}
                                        onChange={handleStatusStateChange}
                                        error={statusState.remarks.error}
                                        required={statusState.remarks.isRequired}
                                        placeholder="Enter remarks"
                                    />
                                </div>
                                <div className="mt-3">
                                    <button type="submit" className="btn btn-success me-2"
                                        onClick={() => {
                                            handleStatusUpdateSubmit()

                                        }}
                                    >Submit</button>
                                    <button className="btn btn-danger text-white" onClick={() => {
                                        const modal = window.bootstrap.Modal.getInstance(document.getElementById(`statusUpdateModal`));
                                        if (modal) modal.hide();
                                    }}>Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* <a
                    href={`${process.env.REACT_APP_BASE_URL}/v3/ncr/download/:type/:ncrId`.replace(':type', 'pdf').replace(':ncrId', ncrDetail?.ID)}
                    target='_blank'

                    className="btn btn-sm btn-primary me-2"
                    style={{
                        backgroundImage:
                            "linear-gradient(90deg, rgb(104, 149, 180), rgb(38, 85, 120))"
                    }}
                >
                    <i className="fas fa-file label-icon" /> Export as PDF

                </a> */}

                <div className="dropdown">
                    <button
                        type="button"
                        className="btn btn-sm btn-primary me-2 mt-1  dropdown-toggle"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        style={{
                            backgroundImage:
                                "linear-gradient(90deg, rgb(104, 149, 180), rgb(38, 85, 120))",
                        }}
                    >
                        <i className="fas fa-file label-icon" /> Export
                    </button>
                    <ul className="dropdown-menu" >
                        <li>
                            <a
                                href={`${process.env.REACT_APP_BASE_URL}/v3/ncr/download/pdf/${ncrDetail?.ID}`}
                                target="_blank"
                                className="dropdown-item"
                            >
                                PDF
                            </a>
                        </li>
                        <li>
                            <a
                                href={`${process.env.REACT_APP_BASE_URL}/v3/ncr/download/docx/${ncrDetail?.ID}`}
                                target="_blank"
                                className="dropdown-item"
                            >
                                DOC
                            </a>
                        </li>
                        <li>
                            <li>
                                <button
                                    className="dropdown-item"
                                    onClick={() => setPreviewItem(ncrDetail)}
                                    data-bs-toggle="modal"
                                    data-bs-target="#previewModal"
                                >
                                    Preview
                                </button>
                            </li>
                        </li>


                    </ul>
                </div>
                <div
                    className="modal fade"
                    aria-hidden="true"
                    id="previewModal"
                    data-bs-backdrop="static"
                    data-bs-keyboard="false"
                    tabIndex={-1}
                    role="dialog"
                    aria-labelledby="previewModalLabel"
                >
                    <div className="modal-dialog modal-dialog-centered modal-xl" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Preview</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                    onClick={() => setPreviewItem(null)}
                                />
                            </div>

                            <div
                                className="modal-body d-flex justify-content-center align-items-center"
                                style={{ height: "80vh" }}
                            >
                                {loading ? (
                                    <div style={{ fontSize: "18px", fontWeight: "500", color: "#555" }}>
                                        Loading...
                                    </div>
                                ) : pdfUrl ? (
                                    <iframe
                                        src={pdfUrl}
                                        title="PDF Preview"
                                        width="100%"
                                        height="100%"
                                        style={{ border: "none" }}
                                    />
                                ) : (
                                    <p className="text-muted">No preview available</p>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


    )
}

export default Header
